<template>
  <v-container fluid>
    <v-combobox
      v-model="params"
      :items="category"
      :search-input.sync="search"
      :loading="loading"
      :label="labelText"
      item-value="id"
      item-text="name"
      multiple
      persistent-hint
      small-chips
    >
      <template #selection="{ attrs, item, parent }">
        <v-chip label outlined v-bind="attrs">
          <span v-if=" item !== undefined" class="pr-2">
            {{ item.id }} {{ item.name }}
          </span>
          <v-icon small @click="parent.selectItem(item)">
            mdi-close
          </v-icon>
        </v-chip>
      </template>
      <template #item="{ item }">
        {{ item.id }} {{ item.name }}
      </template>

      <template #no-data>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title> Введите для поиска </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-combobox>
  </v-container>
</template>

<script>
import { Categores } from '@/graphql/category'
export default {
  apollo: {
    Category: {
      query: Categores,
      result ({ data, loading }) {
        this.loading = loading
        this.category = data?.categores
      },
      update: data => data?.categores
    }
  },
  props: {
    default: {
      type: [Array, Object]
      // eslint-disable-next-line vue/require-valid-default-prop
      // default: []
    },
    labelText: {
      type: String,
      default: 'Категории'
    },
    openDialog: {
      type: Boolean
    }
  },
  data: () => ({
    loading: true,
    category: [],
    search: null
  }),
  computed: {
    params: {
      get () {
        return this?.default?.map((i) => { return this.category.filter((f) => { return f.id === i })[0] })
      },
      set (val) {
        this.$emit('selected', val.filter(i => !!i.id))
      }
    }
  }
}
</script>
